<template>
  <!-- 这个是福利这块 -->
  <div class="achievementmain">
    <div class="sign">
      <div class="" v-if="getTheme == 'khalaspay'"></div>
      <img class="sign_bg" v-else :src="imgList[getTheme].signBg" alt="" />
      <div class="sign_box">
        <!-- to='/record'  -->
        <div class="sign_router_gold" @click="urlOpen('/record')">
          {{ $t("boon.sing") }}
          <img class="sign_router_gold_img" src="@/img/next.png" alt="" />
        </div>
        <div class="my_gold">
          <div class="my_gold_left">
            <div class="my_gold_url">
              <img class="my_gold_img" src="@/img/Diamonds.png" alt="" />
            </div>
            <div class="my_gold_box" @click="openDiamond">
              <div class="my_gold_sum">
                {{ balance }}
              </div>
              <div class="my_gold_btn">
                <img class="power_add" src="@/img/tga_add_m.png" alt />
              </div>
            </div>
          </div>
          <div class="my_gold_rigth"></div>
        </div>

        <div class="my_gold">
          <div class="my_gold_left">
            <div class="my_gold_url">
              <img class="my_gold_img" src="@/img/coin.png" alt="" />
            </div>
            <div class="my_gold_box" @click="showConversionGold">
              <div class="my_gold_sum">
                {{ gold }}
              </div>
              <div class="my_gold_btn">
                <img class="power_add" src="@/img/tga_add_m.png" alt />
              </div>
            </div>
          </div>
          <div class="my_gold_rigth">
            <div v-if="chekinsum.signed" class="chekin_active">
              {{ $t("boon.chekin") }}
            </div>
            <div v-else class="chekin" @click="setSign">
              {{ $t("boon.no_chekin") }}
            </div>
          </div>
        </div>

        <!--  <div class="gold_box">
          <div class="gold_text">{{ $t('boon.mysing') }}</div>
          <div class="gold">
            <div class="gold_sum">{{ gold }}</div>

            <div v-if="chekinsum.signed" class="chekin_active">{{ $t('boon.chekin') }}</div>
            <div v-else class="chekin" @click="setSign">{{ $t('boon.no_chekin') }}</div>
          </div>
        </div> -->
        <div class="chekin_text">
          {{ $t("boon.chekin_text") }}
          <span class="chekin_sum">{{ chekinsum.signdays }}</span>
          {{ $t("boon.day") }}
        </div>

        <div class="chekinList">
          <div class="chekinList_item">
            <div
              class="chekinList_progress chekinList_progress1"
              v-if="chekinsum.signdays <= 1"
            ></div>
            <div
              class="chekinList_progress chekinList_progress2"
              v-else-if="chekinsum.signdays == 2"
            ></div>
            <div
              class="chekinList_progress chekinList_progress3"
              v-else-if="chekinsum.signdays == 3"
            ></div>
            <div
              class="chekinList_progress chekinList_progress4"
              v-else-if="chekinsum.signdays == 4"
            ></div>
            <div
              class="chekinList_progress chekinList_progress5"
              v-else-if="chekinsum.signdays == 5"
            ></div>
            <div
              class="chekinList_progress chekinList_progress6"
              v-else-if="chekinsum.signdays == 6"
            ></div>
            <div class="chekinList_progress chekinList_progress7" v-else></div>
          </div>
          <div class="chekinList_box">
            <!-- chekinList -->
            <div
              class="chekin_day"
              v-for="(item, index) in chekinList"
              :key="index"
            >
              <img
                class="chekin_day_img_li"
                v-if="item.type == 1"
                src="@/img/li.png"
                alt=""
              />
              <img
                class="chekin_day_img"
                v-if="item.type == 0 && chekinsum.signdays - 1 >= index"
                src="@/img/chekin.png"
                alt=""
              />
              <img
                class="chekin_day_img"
                v-if="item.type == 0 && chekinsum.signdays - 1 < index"
                src="@/img/no_chekin.png"
                alt=""
              />

              <div class="chekin_day_text">{{ item.day }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="achievement_router">
      <div @click="urlOpen('/achievement')" class="achievement_router_btn">
        <!-- <img
          class="achievement_router_btn_bg"
          :src="require('@/img/achievement-' + getTheme + '.png')"
          alt=""
        /> -->
        <img
          class="achievement_router_btn_bg"
          :src="imgList[getTheme].achievement || ''"
          alt=""
        />
        <!-- <img
          class="achievement_router_btn_bg"
          v-if="getTheme == 1"
          src="@/img/a1.png"
          alt=""
        />
        <img
          class="achievement_router_btn_bg"
          v-else
          src="@/img/a.png"
          alt=""
        /> -->

        <div class="achievement_router_title">{{ $t("boon.achievement") }}</div>
        <div class="achievement_router_text">{{ $t("boon.check") }}</div>
      </div>
      <div
        class="achievement_router_btn"
        @click="tipMessage({ context: $t('boon.coming_soon') })"
      >
        <img
          class="achievement_router_btn_bg"
          :src="imgList[getTheme].jinbi"
          alt=""
        />
        <!-- <img
          class="achievement_router_btn_bg"
          :src="require('@/img/jinbi-' + getTheme + '.png')"
          alt=""
        /> -->
        <!-- <img
          class="achievement_router_btn_bg"
          v-if="getTheme == 1"
          src="@/img/jinbi-khalaspay.png"
          alt=""
        />
        <img
          class="achievement_router_btn_bg"
          v-else
          src="@/img/jinbi.png"
          alt=""
        /> -->
        <div class="achievement_router_title">{{ $t("boon.gold_mall") }}</div>
        <div class="achievement_router_text_coin">{{ $t("boon.check") }}</div>
      </div>
    </div>

    <div class="quest">
      <div class="quest_title">{{ $t("boon.quest") }}</div>
      <div class="quest_box">
        <div class="quest_list" v-for="(item, index) in tasksList" :key="index">
          <div class="quest_centent">
            <div class="quest_centent_left">
              <div class="quest_icon">
                <!-- <img
                  class="quest_icon_img"
                  v-if="item.icon"
                  :src="item.icon"
                  alt=""
                /> -->
                <!-- v-else -->
                <img class="quest_icon_img" src="@/img/tasks.png" alt="" />
              </div>
              <div class="quest_text">
                {{ item.name }}({{
                  item.userState.finishCnt > item.userState.totalCnt
                    ? item.userState.totalCnt
                    : item.userState.finishCnt
                }}/{{ item.userState.totalCnt }})
              </div>
            </div>
            <div class="quest_btn1" v-if="item.userState.state == 0">
              {{ $t("boon.no_complete") }}
            </div>
            <div
              class="quest_btn"
              v-if="item.userState.state == 1"
              @click="getTasksReward(item.id)"
            >
              {{ $t("boon.get") }}
            </div>
            <div class="quest_btn2" v-if="item.userState.state == 2">
              {{ $t("boon.complete") }}
            </div>
          </div>
          <div class="quest_sum">
            {{ item.reward[0].cnt }}{{ $t(`boon.${item.reward[0].type}`) }}
          </div>
        </div>
      </div>
    </div>

    <!-- 大奖弹出款 -->
    <div class="bip_prize_box" v-if="isBigPrize" @click="bigPrize">
      <div class="bip_prize_bg"></div>
      <div class="bip_prize_centent">
        <div class="bip_prize_url_box">
          <div class="bip_prize_url">
            <img class="bip_prize_img" src="@/img/close.png" alt="" />
          </div>
        </div>

        <img class="bip_prize_img_bg" src="@/img/prize_box.png" alt="" />
        <div class="bip_prize_text">
          <img class="bip_prize_text_img" src="@/img/coin.png" alt="" />
          {{ cnt }}
        </div>
      </div>
    </div>

    <ConversionGold
      v-if="goldStatus"
      :goldStatus="goldStatus"
      @setGoldStatus="getGoldStatus"
    ></ConversionGold>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
import ConversionGold from "@/components/gold/index";
export default {
  components: {
    ConversionGold
  },
  data() {
    return {
      isBigPrize: false,
      chekinsum: 0,
      tasksList: [],
      chekinList: [],
      cnt: 0,
      goldStatus: false,
      getTheme: 0,
      imgList: {
        khalaspay: {
          jinbi: require("@/img/jinbi-khalaspay.png"),
          achievement: require("@/img/achievement-khalaspay.png"),
          signBg: require("@/img/sign-blue.jpg")
        },
        dark: {
          jinbi: require("@/img/jinbi-dark.png"),
          achievement: require("@/img/achievement-dark.png"),
          signBg: require("@/img/sign-dark.jpg")
        },
        lavender: {
          jinbi: require("@/img/jinbi-regular.png"),
          achievement: require("@/img/achievement-regular.png"),
          signBg: require("@/img/sign-lavender.jpg")
        },
        orange: {
          jinbi: require("@/img/jinbi-regular.png"),
          achievement: require("@/img/achievement-regular.png"),
          signBg: require("@/img/sign-orange.jpg")
        },
        "night-blue": {
          jinbi: require("@/img/jinbi-night-blue.jpg"),
          achievement: require("@/img/achievement-night-blue.jpg"),
          signBg: require("@/img/sign-blue.jpg")
        },
        regular: {
          jinbi: require("@/img/jinbi-regular.png"),
          achievement: require("@/img/achievement-regular.png"),
          signBg: require("@/img/sign.jpg")
        }
      }
    };
  },
  created() {
    this.getTheme = configs.getTheme();
  },
  mounted() {
    var self = this;
    this.getSignState();
    this.getUserSignRewards();

    this.getTasksList();
    this.getCoin();
    document.addEventListener("visibilitychange", e => {
      if (document.hidden) {
        // 页面被挂起
      } else {
        self.getCoin();
        // 页面呼出
      }
    });
  },
  computed: {
    ...mapState("pay", ["gold", "balance"])
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("pay", ["Coin"]),
    ...mapActions("game", [
      "userSignState",
      "userSign",
      "getReward",
      "tasks",
      "userSignRewards"
    ]),
    // 获取金币兑换弹窗
    getGoldStatus(data) {
      this.goldStatus = data;
    },

    // 点击金币兑换
    showConversionGold() {
      this.goldStatus = true;
    },
    openDiamond() {
      var navigationbar =
        configs.GetQueryString("navigationbar") ||
        this.$route.query.navigationbar;
      this.$router.push({
        path: "/diamond",
        query: {
          navigationbar: navigationbar
        }
      });

      // if (TgaBridge) {
      //  let locationUrl = window.location.origin
      //   if (locationUrl == 'https://tga.just4fun.sg') {
      //     locationUrl = 'https://tga.just4fun.sg/h5tga4bip/'
      //   }else{
      //      locationUrl = 'https://data.just4fun.sg/h5tga4bip/tgabip/'
      //   }
      // 			let url =	locationUrl +window.location.search +
      // 				'#/diamond';
      // 			let goPageUrl = {
      // 				url: url,
      // 				navigationBar: {
      // 					display: false
      // 					// backgroundColor:"#ffffff"
      // 				},
      // 				statusBarDisplay: {
      // 					display: true,
      // 					backgroundColor: '#50000000'
      // 				}
      // 			};
      // 			configs.goPageData(goPageUrl);
      // 		}else{
      //       this.$router.push({
      //         	path: '/diamond',
      //       })
      //     }
    },

    // 查询金币余额
    getCoin() {
      const self = this;
      const res = this.Coin({
        $axios: this.$axios,
        appId: configs.bipAppId()
      });
    },
    // 用户签到
    async setSign() {
      const res = await this.userSign({
        $axios: this.$axios
      });
      if (res.stateCode == 1) {
        this.getCoin();
        const data = res.resultInfo.data;
        this.chekinsum.signed = true;
        this.chekinsum.signdays = data;
        if (data == 7) {
          this.cnt = this.chekinList[data - 1].reward[0].cnt;
          this.isBigPrize = true;
        } else {
          this.tipMessage({
            context:
              "+" +
              this.chekinList[data - 1].reward[0].cnt +
              this.$t(`boon.${this.chekinList[data - 1].reward[0].type}`)
          });
        }
      } else {
        switch (res.stateCode) {
          case -1110:
            this.tipMessage({
              context: this.$t("boon.checked")
            });
            break;
          case -1111:
          case -1112:
            this.tipMessage({
              context: this.$t("config.server")
            });
            break;
          default:
            this.tipMessage({
              context: this.$t("config.server")
            });
            break;
        }
      }
    },
    getUserSignRewards() {
      const self = this;
      const res = this.userSignRewards({
        $axios: this.$axios
      }).then(res => {
        if (res.stateCode == 1) {
          self.chekinList = res.resultInfo.data;
        } else {
          self.tipMessage({
            context: this.$t("config.server")
          });
        }
      });
    },

    // 用户签到状态
    getSignState() {
      const self = this;
      const res = this.userSignState({
        $axios: this.$axios
      }).then(res => {
        if (res.stateCode == 1) {
          self.chekinsum = res.resultInfo.data;
        }
      });
    },

    // 获取任务列表
    getTasksList() {
      const self = this;
      const res = this.tasks({
        $axios: this.$axios
      }).then(res => {
        if (res.stateCode == 1) {
          self.tasksList = res.resultInfo.data;
        }
      });
    },

    // 领取任务奖励
    async getTasksReward(id) {
      const res = await this.getReward({
        $axios: this.$axios,
        rewardId: id,
        rewardType: 0
      });
      if (res.stateCode == 1) {
        this.getTasksList();
        const data = res.resultInfo.data[0];
        this.getCoin();
        this.tipMessage({
          context: data.cnt + "" + this.$t(`boon.${data.type}`)
        });
      }
    },

    bigPrize() {
      this.isBigPrize = false;
    },

    // 点击跳转金币记录
    urlOpen(url) {
      this.$router.push({
        path: url
      });
      // if (window.TgaBridge) {
      //   TgaBridge.goPage(configs.goPageUrl() + url, res => {});
      // } else {
      //   this.$router.push({
      //     path: url
      //   });
      // }
    }
  }
};
</script>

<style scoped="scoped">
.achievementmain {
  padding: 0 0.4rem 0.6rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: var(--bg);
}
.sign {
  box-sizing: border-box;
  width: 100%;
  height: 6.11rem;
  background-color: var(--bonusTopBackground);
  border-radius: 0.29rem 1.15rem 0.29rem 0.29rem;
  position: relative;
}
.sign_bg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}
.sign_box {
  position: relative;
  width: 100%;
  height: 100%;

  z-index: 2;
  padding-top: 0.9rem;
}
.sign_router_gold {
  position: absolute;
  padding: 0.5rem 0.89rem 0;
  top: 0;
  right: 0;
  font-size: 0.36rem;
  color: #ffffff;
}

.sign_router_gold_img {
  margin-left: 0.23rem;
  width: 0.16rem;
  height: 0.31rem;
}
/*  */
.my_gold {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0.48rem;
  padding-top: 0.16rem;
  /* background: red; */
}
.my_gold_left {
  display: flex;
  background-color: var(--boonMyGoldBackground);
  width: 4.75rem;
  /* height: 0.72rem; */
  /* background-color: rgba(255, 255, 255, 0.2); */
  /* opacity: 0.2; */
  border-radius: 0.6rem;
  /* margin-left: 0.2rem; */
  /* padding-left: 0.2rem; */
}
.my_gold_url {
  width: 0.74rem;
  height: 0.74rem;
}
.my_gold_img {
  width: 0.74rem;
  height: 0.74rem;
}
.my_gold_rigth {
  padding-right: 0.89rem;
  display: flex;
  justify-content: space-between;
}
.my_gold_box {
  display: flex;
}
.my_gold_sum {
  width: 2.84rem;
  font-size: 0.56rem;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.2rem;
}
.my_gold_btn {
  font-size: 0.56rem;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-left: 0.2rem;
}
.power_add {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
}

.gold_box {
  padding-top: 1.06rem;
  padding-right: 0.89rem;
  margin-left: 2.71rem;
  /* display: flex; */
}
.gold_text {
  margin-bottom: 0.22rem;
  color: #ffffff;
  font-size: 0.36rem;
}

.gold {
  display: flex;
  justify-content: space-between;
}

.gold_sum {
  font-size: 0.78rem;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.chekin {
  width: 2.41rem;
  height: 0.91rem;
  background-image: var(--bonusTopBtnBackground);
  box-shadow: 0px 0.05rem 0.05rem 0px rgba(0, 0, 0, 0.1);
  border-radius: 0.45rem;
  color: var(--bonusTopBtnColor);
  font-size: 0.42rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chekin_active {
  width: 2.41rem;
  height: 0.91rem;
  background-image: var(--bonusTopBtnBackgroundActive);
  box-shadow: 0px 0.05rem 0.05rem 0px rgba(0, 0, 0, 0.1);
  border-radius: 0.45rem;
  color: #ffffff;
  font-size: 0.42rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chekin_text {
  padding-left: 0.65rem;
  margin-top: 0.3rem;
  font-size: 0.42rem;
  color: #ffffff;
}
.chekin_sum {
  font-size: 0.6rem;
  color: #ffdd16;
  margin: 0 0.2rem;
}
.chekinList {
  box-sizing: border-box;
  margin-top: 0.28rem;
  padding-right: 0.3rem;
  padding-left: 0.48rem;
  position: relative;
}
.chekinList_item {
  width: 8.65rem;
  height: 0.14rem;
  background-color: #ffffff;
  position: absolute;
  top: 0.36rem;
  left: 0.76rem;
  z-index: 1;
}
.chekinList_progress {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fee988;
}
.chekinList_progress1 {
  width: 0%;
}
.chekinList_progress2 {
  width: 16%;
}
.chekinList_progress3 {
  width: 32%;
}
.chekinList_progress4 {
  width: 48%;
}
.chekinList_progress5 {
  width: 67%;
}
.chekinList_progress6 {
  width: 83%;
}
.chekinList_progress7 {
  width: 100%;
}

.chekinList_box {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  width: 9.1rem;
}
.chekin_day {
  width: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* position: absolute;
    top: 0;
    left: 0.57rem; */
}
.chekin_day_img {
  width: 0.73rem;
  height: 0.81rem;
}
.chekin_day_img_li {
  width: 1.23rem;
  height: 0.81rem;
}
.chekin_day_text {
  margin-top: 0.2rem;
  font-size: 0.3rem;
  color: #ffffff;
}
.chekin_day_text_active {
  color: #ffdd16;
}
.achievement_router {
  margin-top: 0.44rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.achievement_router_btn {
  width: 4.8rem;
  height: 2.81rem;
  border-radius: 0.3rem;
  padding-left: 0.4rem;
  padding-top: 0.46rem;
  position: relative;
  /* background-color: red; */
}
.achievement_router_btn_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.achievement_router_title {
  position: relative;
  z-index: 2;
  font-size: 0.42rem;
  color: #ffffff;
}

.achievement_router_text {
  margin-top: 0.3rem;
  position: relative;
  z-index: 2;
  width: 1.8rem;
  height: 0.62rem;
  background-color: var(--bonusViewBg);
  border-radius: 0.31rem;
  font-size: 0.36rem;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.achievement_router_text_coin {
  margin-top: 0.3rem;
  position: relative;
  z-index: 2;
  width: 1.8rem;
  height: 0.62rem;
  background-color: var(--bonusViewGoIdBg);
  border-radius: 0.31rem;
  font-size: 0.36rem;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.quest {
  margin-top: 0.39rem;
  background-color: var(--questBackground);
  border-radius: 0.3rem;
  width: 100%;
  padding: 0.6rem 0.38rem 0.6rem 0.5rem;
}
.quest_title {
  color: var(--questTitleColor);
  font-size: 0.48rem;
  font-weight: bold;
  margin-bottom: 0.23rem;
}
.quest_list {
  padding-top: 0.6rem;
  padding-bottom: 0.1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.quest_centent {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.quest_centent_left {
  display: flex;
  align-items: center;
}
.quest_icon {
  width: 0.49rem;
  height: 0.61rem;
  display: flex;
  align-items: center;
}
.quest_icon_img {
  width: 100%;
  height: 100%;
}
.quest_text {
  margin-left: 0.5rem;
  width: 5.3rem;
  color: var(--questListTitleColor);
  font-size: 0.42rem;
}
.quest_btn {
  width: 2.01rem;
  height: 0.87rem;
  background-image: var(--questListBtnBackground);
  border-radius: 0.43rem;
  border: solid 0.03rem var(--questListBtnBackground);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.36rem;
}
.quest_btn1 {
  width: 2.21rem;
  height: 0.87rem;
  background-image: var(--questlistbtnbackground1);
  border-radius: 0.43rem;
  /* border: solid 0.03rem #1ac2ff; */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.36rem;
}
.quest_btn2 {
  width: 2.01rem;
  height: 0.87rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.36rem;
  color: var(--questListBtnColor2);
}
.quest_sum {
  margin-top: 0.3rem;
  font-size: 0.35rem;
  color: var(--questListTextColor);
  margin-left: 1.14rem;
}

.bip_prize_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bip_prize_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.8);
}
.bip_prize_centent {
  position: relative;
  z-index: 2;
}
.bip_prize_url_box {
  display: flex;
  justify-content: flex-end;
}
.bip_prize_url {
  padding-right: 0.76rem;
  position: absolute;
  top: 0.4rem;
}
.bip_prize_img {
  width: 0.85rem;
  height: 0.85rem;
}
.bip_prize_img_bg {
  width: 10.58rem;
  height: 10.59rem;
}
.bip_prize_text {
  position: relative;
  top: -1.8rem;
  font-size: 0.6rem;
  color: #ffdd16;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bip_prize_text_img {
  margin-right: 0.2rem;
  width: 0.69rem;
  height: 0.71rem;
}
</style>



// WEBPACK FOOTER //
// src/components/boon.vue